import { Navigate, Route, Routes } from 'react-router-dom'
import {
  ACTIVATE_ACCOUNT_ROUTE,
  ADMIN_ROUTE,
  ADMIN_SUBSCRIPTIONS_ROUTE,
  ADMIN_VIEW_ROUTE,
  HOME_ROUTE,
  LOGIN_ROUTE,
  PORTAL_ROUTE,
  REGISTER_ROUTE,
  UNITS_ROUTE,
} from '../../config'
import { AdminComponent } from '../Admin'
import { GuardedRoute } from './GuardedRoute'
import { HomeComponent } from '../Home'
import { UnitsComponent } from '../Units'
import { LoginComponent } from '../Login'
import { ErrorPage } from '../ErrorPage'
import { RegisterComponent } from '../Register'
import { PortalComponent } from '../Portal'
import { PortalAccessClaimComponent } from '../PortalAccessClaim'

interface AppRoutesProp {
  isAuthenticated: boolean
  isAdmin: boolean
}

export const AppRoutes = (props: AppRoutesProp): JSX.Element => {
  const { isAuthenticated, isAdmin } = props

  return (
    <Routes>
      <Route path={HOME_ROUTE} element={<HomeComponent />} />
      <Route path={UNITS_ROUTE} element={<UnitsComponent />} />
      <Route path={REGISTER_ROUTE} element={<RegisterComponent />} />
      <Route path={LOGIN_ROUTE} element={<LoginComponent />} />
      <Route
        path={ACTIVATE_ACCOUNT_ROUTE}
        element={<PortalAccessClaimComponent />}
      />

      <Route
        element={
          <GuardedRoute
            isRouteAccessible={isAuthenticated && !isAdmin}
            redirectRoute={isAuthenticated ? ADMIN_SUBSCRIPTIONS_ROUTE : HOME_ROUTE}
          />
        }
      >
        <Route path={PORTAL_ROUTE} element={<PortalComponent />} />
      </Route>
      <Route
        element={
          <GuardedRoute
            isRouteAccessible={isAuthenticated && isAdmin}
            redirectRoute={isAuthenticated ? PORTAL_ROUTE : HOME_ROUTE}
          />
        }
      >
        <Route
          path={ADMIN_ROUTE}
          element={<Navigate to={ADMIN_SUBSCRIPTIONS_ROUTE} replace />}
        />
        <Route path={ADMIN_VIEW_ROUTE} element={<AdminComponent />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  )
}
